module.exports = __webpack_public_path__ + "img/4d671deff36afdc4f9f4ead974afd851.png";